import React from "react";

function FieldNoteSearch({ value, onChange }) {
  return (
    <aside className="package-widget widget-search">
      <div className="widget-title">
        <h4>Search Field Notes</h4>
      </div>
      <div className="widget-body">
        <input
          className="form-control"
          type="search"
          placeholder="Keyword in title or author"
          value={value}
          onChange={(event) => onChange(event.target.value)}
        />
      </div>
    </aside>
  );
}

export default FieldNoteSearch;
